<div class="container mt-4">
  <h1 class="h3 mb-2 text-gray-800">
    <i class="fas fa-list"></i> {{ categoryI18n?.allTitleI18n || 'Danh mục' }}
  </h1>

  <p class="mb-4">
    Module Danh mục là một phần quan trọng của phần mềm quản lý thư viện, được thiết kế để tổ chức và phân loại sách, tài liệu và các nguồn tài nguyên khác. Nó cho phép thủ thư tạo, quản lý và xuất bản danh mục, giúp người dùng dễ dàng tìm kiếm và truy cập tài nguyên.
  </p>

  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#Overview">
        <i class="fas fa-chart-bar mr-2"></i> Tổng quan
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#List">
        <i class="fas fa-list mr-2"></i> Danh sách
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#UserManual">
        <i class="fas fa-book mr-2"></i> Hướng dẫn sử dụng
      </a>
    </li>
  </ul>

  <div class="tab-content">
    <!-- Overview tab -->
    <div id="Overview" class="tab-pane custom-tab-pane">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6">
            <h4 class="text-center">Số sách theo danh mục</h4>
            <ngx-charts-bar-vertical
              [results]="barChartData"
              [view]="[400,300]"
              [scheme]="'cool'"
              [gradient]="true"
              [xAxis]="true"
              [yAxis]="true"
              [legend]="false"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              xAxisLabel="Danh mục"
              yAxisLabel="Số lượng sách">
            </ngx-charts-bar-vertical>
          </div>

          <div class="col-md-6">
            <h4 class="text-center">Phân bố sách theo thể loại</h4>
            <ngx-charts-pie-chart
              [results]="pieChartData"
              [view]="[400,300]"
              [scheme]="'cool'"
              [legend]="false"
              [explodeSlices]="false"
              [labels]="true">
            </ngx-charts-pie-chart>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <h4 class="text-center">Xu hướng số lượng sách theo thời gian</h4>
            <ngx-charts-line-chart
              [results]="lineChartData"
              [view]="[400,300]"
              [scheme]="'cool'"
              [legend]="false"
              [xAxis]="true"
              [yAxis]="true"
              [autoScale]="true">
            </ngx-charts-line-chart>
          </div>

          <div class="col-md-6">
            <h4 class="text-center">Sách theo thể loại</h4>
            <ngx-charts-pie-chart
              [results]="doughnutChartData"
              [view]="[400,300]"
              [scheme]="'cool'"
              [legend]="false"
              [explodeSlices]="false"
              [doughnut]="true"
              [labels]="true">
            </ngx-charts-pie-chart>
          </div>
        </div>
      </div>
    </div>

    <!-- List tab -->
    <div id="List" class="tab-pane show active custom-tab-pane">
      <div class="container-fluid">
        <div *ngIf="loading; else loaded">
          <div class="d-flex justify-content-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Đang tải...</span>
            </div>
          </div>
        </div>

        <ng-template #loaded>
          <app-statistics-category [categoryI18n]="categoryI18n"></app-statistics-category>

          <div class="card mb-4">
            <div class="card-body">
              <div class="table-responsive">

                <!-- Danh sách danh mục -->
                <app-category-list
                  (editEvent)="edit($event)"
                  (deleteEvent)="delete($event)"
                  [categories]="categorys$"
                  [categoryI18n]="categoryI18n">
                </app-category-list>

                <!-- Modal danh mục -->
                <app-modal-category
                  [categoryI18n]="categoryI18n"
                  [id]="id">
                </app-modal-category>

              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- User Manual -->
    <div id="UserManual" class="tab-pane custom-tab-pane">
      <div>
        <div [innerHTML]="markdownContent"></div>
      </div>
    </div>
  </div>
</div>